export default __webpack_public_path__ + "static/media/producto-23.26a8bdf6.jpeg";